export class Closure {
    startDate: string;
    endDate: string;
}